import React, { useEffect } from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer';
import StatsSection from '../../components/StatsSection';
import ProcessSection from '../../components/ProcessSection';
import Newsletter from '../../components/Newsletter';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet";

const FaqItem = ({ question, answer, defaultOpen = false }) => {
  const [open, setOpen] = React.useState(defaultOpen);
  return (
    <div className="accordion-item">
      <h2 className="accordion-header">
        <button
          className={`accordion-button ${open ? '' : 'collapsed'}`}
          type="button"
          onClick={() => setOpen(prev => !prev)}
        >
          {question}
        </button>
      </h2>
      <div className={`accordion-collapse collapse ${open ? 'show' : ''}`}> 
        <div className="accordion-body">{answer}</div>
      </div>
    </div>
  );
};

export default function MonogramDigitizing() {

    const monogramSteps = [
        { number: "01", title: "Submit Your Design", description: "Send your initials, monogram, or artwork in JPG, PNG, PDF, or AI format.", icon: "📤" },
        { number: "02", title: "Monogram Digitizing", description: "We convert your design into a machine-ready embroidery file optimized for monogram stitching.", icon: "⚡" },
        { number: "03", title: "Quality Check", description: "We refine stitch density, paths, and details for precise and elegant results.", icon: "✓" },
        { number: "04", title: "File Delivery", description: "Receive your embroidery files in DST, PES, JEF, and other compatible formats.", icon: "🚀" }
    ];

    return (
        <>

            <Helmet>
                <title>Monogram Embroidery Digitizing Services Los Angeles, CA | Grand Indigo Embroidery</title>
                <meta name="description" content="Custom monogram embroidery digitizing services in Los Angeles, CA. Elegant and precise monogram stitch files for apparel and branding." />
                <meta name="keywords" content="monogram digitizing, monogram embroidery digitizing, custom monogram digitizing, embroidery digitizing Los Angeles, monogram digitizing near me" />
            </Helmet>

            <Header />

            <section className="breadcrumbsection">
                <div className='container'>
                    <h1>Monogram Digitizing</h1>
                    <ul className='breadcrumblinks'>
                        <li><Link to="/">Home</Link></li>
                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                        <li>Services</li>
                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                        <li>Monogram Digitizing</li>
                    </ul>
                </div>
            </section>


            <section className="service-section">
                <div className="container">
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="case-study-image">
                                <img src="/images/services/monogram1.jpg" alt="Custom Uniform Embroidery" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="case-study-content">
                                <span className="case-study-tag">Elegant. Timeless. Personalized.</span>
                                <h3 className="case-study-title">Professional Monogram Digitizing in Los Angeles</h3>
                                <p className="case-study-description">
                                    At Grand Indigo Embroidery, we provide specialized monogram digitizing services in Los Angeles, California, helping individuals and businesses create elegant, personalized embroidery designs. Monograms require precise digitizing to ensure every letter, initial, or custom symbol is perfectly proportioned and stitched with clarity.
                                </p>
                                <p className="case-study-description">
                                    Our team converts initials, logos, and custom artwork into high-quality, machine-ready stitch files optimized for monogram embroidery. Whether it’s for apparel, towels, bags, or gifts, our monogram embroidery digitizing services ensure professional, consistent, and visually appealing results. If you’re searching for reliable monogram digitizing near you in Los Angeles, Grand Indigo Embroidery delivers precision and quality every time.
                                </p>
                                <Link to="/contact" className="btn btn-primary">Get In Touch</Link>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <StatsSection />

            <section className="service-section">
                <div className="container">
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-6">
                            <div className="case-study-content">
                                <span className="case-study-tag">Precision for Fine Lettering</span>
                                <h3 className="case-study-title">Custom Monogram Digitizing for Personalized Embroidery</h3>
                                <p className="case-study-description">
                                    Our custom monogram digitizing services are designed for businesses, gift shops, bridal embroidery, and fashion brands that require elegant, personalized embroidery designs. We optimize every stitch for your fabric type, size, and embroidery placement, ensuring a flawless finished product.
                                </p>
                                <p className="case-study-description">
                                    From simple initials to ornate monogram logos, we provide files ready for production on all major embroidery machines. Los Angeles clients trust Grand Indigo Embroidery for fast turnaround, accurate results, and professional monogram digitizing. You can also order monogram embroidery digitizing online to get ready-to-use files quickly and conveniently.
                                </p>
                                <Link to="/contact" className="btn btn-primary">Get In Touch</Link>
                            </div>
                        </div>
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="case-study-image">
                                <img src="/images/services/monogram2.jpg" alt="Custom Uniform Embroidery" />
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <ProcessSection steps={monogramSteps} />
                                                            
            <section className="faqs-section">
                <div className="container">
                    <div className="row mb-5">
                        <div className="col-12 text-center">
                            <h2 className="section-title">Frequently Asked Questions</h2>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="accordion" id="faqAccordion">

                                <FaqItem
                                    defaultOpen={true}
                                    question="What is monogram digitizing?"
                                    answer="Monogram digitizing is the process of converting initials, names, or custom symbols into machine-readable embroidery files for personalized embroidery."
                                />

                                <FaqItem
                                    question="Do you offer monogram digitizing services in Los Angeles?"
                                    answer="Yes, Grand Indigo Embroidery provides professional monogram embroidery digitizing services in Los Angeles, California."
                                />

                                <FaqItem
                                    question="Can I order monogram digitizing online?"
                                    answer="Absolutely. You can order monogram embroidery digitizing online and receive optimized files quickly."
                                /> 

                                <FaqItem
                                    question="What types of monogram designs can you digitize?"
                                    answer="We digitize single initials, multi-letter monograms, logos, and custom decorative initials."
                                />

                                <FaqItem
                                    question="What items can use monogram embroidery?"
                                    answer="Monogram embroidery can be applied to shirts, jackets, towels, bags, gifts, and promotional items."
                                />

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Newsletter />

            <Footer />
        </>
    )
}
